import { TooltipConfig } from "@/interfaces/shared/tooltip";

export const welcomeTooltipsConfig: TooltipConfig = {
  id: "welcome-tour",
  title: "tooltips.welcome.title",
  showConditions: {
    firstRun: true,
    userState: "recruiter",
    routePath: "/recruiter"
  },
  steps: [
    {
      id: "welcome-step-1",
      title: "tooltips.welcome.step1.title",
      description: "tooltips.welcome.step1.description",
      target: "[data-tooltip-target='dashboard']",
      position: {
        horizontal: "right",
        vertical: "top"
      },
      targetOffset: {
        top: 0,
        left: 25
      },
      highlightTarget: true
    },
    {
      id: "welcome-step-2",
      title: "tooltips.welcome.step2.title",
      description: "tooltips.welcome.step2.description",
      target: ".statistics-section, [data-tooltip-target='statistics']",
      position: {
        horizontal: "center",
        vertical: "top"
      }
    },
    {
      id: "welcome-step-3",
      title: "tooltips.welcome.step3.title",
      description: "tooltips.welcome.step3.description",
      target: ".matching-candidates-section, [data-tooltip-target='candidates']",
      position: {
        horizontal: "center",
        vertical: "top"
      },
      targetOffset: {
        top: 0,
        left: 0
      },
      highlightTarget: true
    }
  ]
};

export const dashboardTooltipsConfig: TooltipConfig = {
  id: "dashboard-features",
  title: "tooltips.dashboard.title",
  showConditions: {
    userState: "recruiter",
    routePath: "/recruiter"
  },
  steps: [
    {
      id: "dashboard-step-1",
      title: "tooltips.dashboard.step1.title",
      description: "tooltips.dashboard.step1.description",
      target: "[data-tooltip-target='jobs-menu'], .jobs-section",
      position: {
        horizontal: "right",
        vertical: "bottom"
      }
    },
    {
      id: "dashboard-step-2",
      title: "tooltips.dashboard.step2.title",
      description: "tooltips.dashboard.step2.description",
      target: "[data-tooltip-target='interviews-menu'], .interviews-section",
      position: {
        horizontal: "right",
        vertical: "bottom"
      }
    }
  ]
};

export const candidateTooltipsConfig: TooltipConfig = {
  id: "candidate-welcome",
  title: "tooltips.candidate.title",
  showConditions: {
    firstRun: true,
    userState: "candidate",
    routePath: "/candidate"
  },
  steps: [
    {
      id: "candidate-step-1",
      title: "tooltips.candidate.step1.title",
      description: "tooltips.candidate.step1.description",
      position: {
        horizontal: "center",
        vertical: "top"
      }
    },
    {
      id: "candidate-step-2",
      title: "tooltips.candidate.step2.title",
      description: "tooltips.candidate.step2.description",
      target: "[data-tooltip-target='applications'], .applications-section",
      position: {
        horizontal: "center",
        vertical: "bottom"
      }
    }
  ]
};

export const postJobTooltipsConfig: TooltipConfig = {
  id: "post-job-tour",
  title: "tooltips.post-job.title",
  showConditions: {
    userState: "recruiter",
    routePath: "/recruiter/jobs/post-job"
  },
  steps: [
    {
      id: "post-job-step-1",
      title: "tooltips.post-job.step1.title",
      description: "tooltips.post-job.step1.description",
      target: "main-content",
      position: {
        horizontal: "left",
        vertical: "top"
      },
      targetOffset: {
        top: 80,
        left: 20
      },
      highlightTarget: false
    },
    {
      id: "post-job-step-2",
      title: "tooltips.post-job.step2.title",
      description: "tooltips.post-job.step2.description",
      target: "[data-tooltip-target='linkedin-card'], .linkedin-option-card",
      position: {
        horizontal: "left",
        vertical: "top"
      },
      targetOffset: {
        top: 10,
        left: -10
      },
      highlightTarget: true
    },
    {
      id: "post-job-step-3",
      title: "tooltips.post-job.step3.title",
      description: "tooltips.post-job.step3.description",
      target: "[data-tooltip-target='upload-card'], .upload-file-card",
      position: {
        horizontal: "right",
        vertical: "top"
      },
      targetOffset: {
        top: 10,
        left: -10
      },
      highlightTarget: true
    },
    {
      id: "post-job-step-4",
      title: "tooltips.post-job.step4.title",
      description: "tooltips.post-job.step4.description",
      target: "[data-tooltip-target='custom-card'], .custom-specifications-card",
      position: {
        horizontal: "right",
        vertical: "top"
      },
      targetOffset: {
        top: 10,
        right: -10
      },
      highlightTarget: true
    }
  ]
};

export const jobListingTooltipsConfig: TooltipConfig = {
  id: "job-listing-tour",
  title: "tooltips.job-listing.title",
  showConditions: {
    userState: "recruiter",
    routePath: "/recruiter/jobs"
  },
  steps: [
    {
      id: "job-listing-step-1",
      title: "tooltips.job-listing.step1.title",
      description: "tooltips.job-listing.step1.description",
      target: "[data-tooltip-target='job-search'], .autocomplete-wrapper",
      position: {
        horizontal: "center",
        vertical: "bottom"
      },
      targetOffset: {
        top: 20,
        left: 0
      },
      highlightTarget: true
    },
    {
      id: "job-listing-step-2",
      title: "tooltips.job-listing.step2.title",
      description: "tooltips.job-listing.step2.description",
      target: "[data-tooltip-target='date-range'], .date-picker-wrapper",
      position: {
        horizontal: "center",
        vertical: "bottom"
      },
      targetOffset: {
        top: 20,
        left: 0
      },
      highlightTarget: true
    }
  ]
};

export const jobDetailsTooltipsConfig: TooltipConfig = {
  id: "job-details-tour",
  title: "tooltips.job-details.title",
  showConditions: {
    userState: "recruiter",
    routePath: "/recruiter/jobs/"
  },
  steps: [
    {
      id: "job-details-step-1",
      title: "tooltips.job-details.step1.title",
      description: "tooltips.job-details.step1.description",
      target: "[data-tooltip-target='edit-details'], .edit-details-btn",
      position: {
        horizontal: "center",
        vertical: "bottom"
      },
      targetOffset: {
        top: 20,
        left: 0
      },
      highlightTarget: true
    }
  ]
};

// Helper function to get tooltip config based on user role and route
export function getTooltipConfig(userRole: string, routePath: string, isFirstRun = false): TooltipConfig | null {
  // Check for post job page tour
  if (userRole === "recruiter" && routePath.includes("/jobs/post-job")) {
    return postJobTooltipsConfig;
  }

  // Check for job listing page tour
  if (userRole === "recruiter" && routePath.includes("/recruiter/jobs") && !routePath.includes("/jobs/post-job")) {
    return jobListingTooltipsConfig;
  }

  // Check for job details page tour (recruiter job view)
  if (userRole === "recruiter" && routePath.match(/^\/recruiter\/jobs\/\d+$/)) {
    return jobDetailsTooltipsConfig;
  }

  // Check for first-time user welcome tour
  if (isFirstRun) {
    if (userRole === "recruiter" && routePath.startsWith("/recruiter")) {
      return welcomeTooltipsConfig;
    }
    if (userRole === "candidate" && routePath.startsWith("/candidate")) {
      return candidateTooltipsConfig;
    }
  }

  // Check for specific dashboard features tour
  if (routePath.startsWith("/recruiter") && routePath === "/recruiter") {
    return dashboardTooltipsConfig;
  }

  return null;
}

// Helper function to check if tooltip should be shown
export function shouldShowTooltip(
  tooltipId: string,
  userRole: string,
  routePath: string,
  completedTooltips: string[] = [],
  isFirstRun = false
): boolean {
  // Don't show if already completed
  if (completedTooltips.includes(tooltipId)) {
    return false;
  }

  const config = getTooltipConfig(userRole, routePath, isFirstRun);
  
  if (!config || config.id !== tooltipId) {
    return false;
  }

  // Check show conditions
  const conditions = config.showConditions;
  if (!conditions) {
    return true;
  }

  // Check user state
  if (conditions.userState && userRole !== conditions.userState) {
    return false;
  }

  // Check route path
  if (conditions.routePath && !routePath.startsWith(conditions.routePath)) {
    return false;
  }

  // Check first run condition
  if (conditions.firstRun && !isFirstRun) {
    return false;
  }

  return true;
}
